import React, { useEffect } from 'react';
import { Layers, FileText, BookOpen } from 'lucide-react';
import useContentGovernanceStore from '@/stores/SuperAdminStore/ContentGovernanceStore';

interface CourseStructureTreeProps {
  courseId: number;
}

/**
 * Read-only Course → Section → Lesson tree for the selected course.
 */
const CourseStructureTree: React.FC<CourseStructureTreeProps> = ({ courseId }) => {
  const { structure, loadingStructure, fetchStructure } = useContentGovernanceStore();

  useEffect(() => { fetchStructure(courseId); }, [courseId, fetchStructure]);

  if (loadingStructure) return <div className="s-admin-ca-empty">Loading structure…</div>;
  if (!structure) return <div className="s-admin-ca-empty">No structure available.</div>;

  return (
    <div className="s-admin-ca-structure">
      <div className="s-admin-ca-structure-head">
        <BookOpen size={16} />
        <strong>{structure.course.title}</strong>
        <span className={`s-admin-ca-status s-admin-ca-status-${structure.course.status}`}>{structure.course.status}</span>
      </div>

      {structure.sections.length === 0 ? (
        <div className="s-admin-ca-empty">This course has no sections yet.</div>
      ) : (
        <ul className="s-admin-ca-sectionlist">
          {structure.sections.map((section) => (
            <li key={section.id} className="s-admin-ca-section">
              <div className="s-admin-ca-section-head">
                <Layers size={14} /> {section.title}
                <span className="s-admin-ca-count">{section.lessons.length} lesson(s)</span>
              </div>
              {section.lessons.length > 0 && (
                <ul className="s-admin-ca-lessonlist">
                  {section.lessons.map((lesson) => (
                    <li key={lesson.id} className="s-admin-ca-lesson">
                      <FileText size={13} />
                      <span>{lesson.title}</span>
                      {lesson.contentType && <span className="s-admin-ca-lesson-type">{lesson.contentType}</span>}
                    </li>
                  ))}
                </ul>
              )}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default CourseStructureTree;
